<template>
  <div v-if="!$store.getters['user/isHirer']">
    <a class="interactive" :class="classes" @click="handleClick">
      {{ label }}
    </a>
  </div>
</template>

<script>
export default {
  props: {
    classes: {
      type: String,
      required: false,
      default: "button tertiary",
    },
    label: {
      type: String,
      required: false,
      default: "List your space",
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    connectOnboardGo() {
      this.loading = true;
      axios
        .get("/api/account/stripe-connect/account/onboard", {
          params: {
            redirect_to: this.redirectTo,
          },
        })
        .then((response) => {
          if (response.data.url) {
            return (window.location.href = response.data.url);
          }
          throw new Error("Invalid onboard link response");
        })
        .catch(() => {
          this.$toasted.show("Could not fetch Stripe connect onboard link", {
            type: "error",
          });
          this.loading = false;
        });
    },
    handleClick() {
      if (!this.$store.getters["user/account"]) {
        this.$store.commit("user/setShouldBeRedirectedToListingForm", true);
        return this.$store.commit("user/changeAuthMode", "login");
      }
      if (!window.location.href.includes("#list-your-space-today")) {
        window.history.pushState(
          "state obj or string",
          "url",
          window.location.href + "#list-your-space-today"
        );
      }
      this.$store.dispatch("modals/showAddListing");
    },
  },
};
</script>
